// Vendors
import { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useIntl } from 'react-intl';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
import { useKycContextConsumerHook } from 'containers/kyc/contexts/kyc.context';
// Constants
import { KYC_LANDING_CONSENT_PROPS } from '../constants/kyc-landing.constants';

// Event Handlers
import { KycLandingHandlers } from '../handlers/kyc-landing.handlers';
import { KycTrackingHandlers } from '../handlers/kyc-landing.tracking.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { KycLandingHookType } from './types/kyc-landing.hook.type';
import { KycLandingConsentType } from '../types/kyc-landing-methods.type';

const useKycLandingHook = (): KycLandingHookType => {
  const { flowApiData } = useLayoutContextConsumerHook(),
    { selectedMethod, setSelectedMethod, setKycIdentificationId, setKycIframeUrl, setKycState } =
      useKycContextConsumerHook(),
    { methods = [] } = flowApiData || {};

  const { showBoundary: setError } = useErrorBoundary();
  const { formatMessage } = useIntl();

  const [videocallConsent, setVideocallConsent] = useState<KycLandingConsentType>({
    ...KYC_LANDING_CONSENT_PROPS,
  } as KycLandingConsentType);

  const {
    handleTrackContinue,
    handleTrackOpenModal,
    handleTrackCloseModal,
    handleTrackCheckConsents,
    handleTrackView,
    handleTrackConfirm,
    handleTrackSelectMethod,
  } = useAppTrackingHook(KycTrackingHandlers);

  useEffect(() => {
    handleTrackView();
  }, []);

  return {
    ...KycLandingHandlers({
      formatMessage,
      handleTrackCheckConsents,
      handleTrackConfirm,
      handleTrackSelectMethod,
      setError,
      setKycIdentificationId,
      setKycIframeUrl,
      setKycState,
      setSelectedMethod,
      setVideocallConsent,
      videocallConsent,
    }),
    handleTrackContinue,
    handleTrackCloseModal,
    handleTrackOpenModal,
    methods,
    selectedMethod,
    videocallConsent,
  };
};

export { useKycLandingHook };
